import ButtonWithTimeout from './ButtonWithTimeout'

export default ButtonWithTimeout
